import { ControlDepartment } from "../../../Project/ViewModel/ControlDepartment";
import { RouteState } from "../../../Project/ViewModel/RouteState";

export class ProposedFtlRoute {
  RouteId: number;
  RouteNumber: string;
  Destination: string;
  LaunchClassification: ControlDepartment;
  CarrierName: string;
  CarrierBranch: string;
  ControlType: string;
  LaunchDate?: Date;
  ReturnLaunchDate?: Date;
  ProjectId: number;
  ProjectName: string;
  ActionStartDate?: Date;
  Roundtrip: boolean;
  ReturnLaunchDateIsCalculated?: boolean;
  RouteState: RouteState;

  constructor(
    routeId: number,
    routeNumber: string,
    destination: string,
    launchClassification: ControlDepartment,
    carrierName: string,
    carrierBranch: string,
    controlType: string,
    launchDate: Date | undefined,
    returnLaunchDate: Date | undefined,
    projectId: number,
    projectName: string,
    actionStartDate: Date | undefined,
    roundtrip: boolean,
    returnLaunchDateIsCalculated: boolean | undefined,
    routeState: RouteState
  ) {
    this.RouteId = routeId;
    this.RouteNumber = routeNumber;
    this.Destination = destination;
    this.LaunchClassification = launchClassification;
    this.CarrierName = carrierName;
    this.CarrierBranch = carrierBranch;
    this.ControlType = controlType;
    this.LaunchDate = launchDate;
    this.ReturnLaunchDate = returnLaunchDate;
    this.ProjectId = projectId;
    this.ProjectName = projectName;
    this.ActionStartDate = actionStartDate;
    this.Roundtrip = roundtrip;
    this.ReturnLaunchDateIsCalculated = returnLaunchDateIsCalculated;
    this.RouteState = routeState;
  }

  static toProposedFtlRoute = (dataItem: unknown) => {
    const item = dataItem as ProposedFtlRoute;
    if (ProposedFtlRoute.isProposedRoute(dataItem)) {
      return new ProposedFtlRoute(
        item.RouteId,
        item.RouteNumber,
        item.Destination,
        item.LaunchClassification,
        item.CarrierName,
        item.CarrierBranch,
        item.ControlType,
        item.LaunchDate,
        item.ReturnLaunchDate,
        item.ProjectId,
        item.ProjectName,
        item.ActionStartDate,
        item.Roundtrip,
        item.ReturnLaunchDateIsCalculated,
        item.RouteState
      );
    }

    throw new Error("Invalid ProposedFtlRoute");
  };

  static isProposedRoute = (dataItem: any): dataItem is ProposedFtlRoute => {
    return (
      "RouteId" in dataItem &&
      "RouteNumber" in dataItem &&
      "Destination" in dataItem &&
      "LaunchClassification" in dataItem &&
      "CarrierName" in dataItem &&
      "CarrierBranch" in dataItem &&
      "ControlType" in dataItem &&
      "LaunchDate" in dataItem &&
      "ReturnLaunchDate" in dataItem &&
      "ProjectId" in dataItem &&
      "ProjectName" in dataItem &&
      "ActionStartDate" in dataItem &&
      "Roundtrip" in dataItem &&
      "ReturnLaunchDateIsCalculated" in dataItem &&
      "RouteState" in dataItem
    );
  };
}
